import React, { FC } from 'react'
import { Navigate } from 'react-router-dom'
import Wrapper from '../../Pages/Skeleton/Wrapper/Wrapper'

import { useAuth } from '../AuthProvider/AuthProvider'

type propType = {
  children: any
}
const ProtectedRoutes:FC<propType> = ({ children }) => {
  const { user }:any = useAuth()

  if (!user) {
    // user is not authenticated
    return <Navigate to="/" />
  }
  return <Wrapper>{children}</Wrapper>
}
export default ProtectedRoutes
